import { DateBadge } from './DateBadge';

export default DateBadge;
